import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { CartProvider } from './context/CartContext';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { Category } from './pages/Category';
import { ProductDetail } from './pages/ProductDetail';
import { Compare } from './pages/Compare';
import { Cart } from './pages/Cart';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
const NotFound = () => <div className="min-h-[60vh] flex flex-col items-center justify-center p-8 text-center bg-gray-50" data-id="element-0">
    <h1 className="text-4xl font-extrabold text-yarbo-dark mb-3" data-id="element-1">404</h1>
    <p className="text-gray-500 max-w-md mb-6" data-id="element-2">
      The page you're looking for doesn't exist.
    </p>
    <a href="/" className="bg-yarbo-dark text-white font-bold px-6 py-3 rounded-lg hover:bg-black" data-id="element-3">
      Return Home
    </a>
  </div>;
export function App() {
  return <CartProvider data-id="element-4">
      <BrowserRouter data-id="element-5">
        <Routes data-id="element-6">
          <Route path="/" element={<Layout data-id="element-8" />} data-id="element-7">
            <Route index element={<Home data-id="element-10" />} data-id="element-9" />
            <Route path="shop" element={<Shop data-id="element-12" />} data-id="element-11" />
            <Route path="category/:slug" element={<Category data-id="element-14" />} data-id="element-13" />
            <Route path="product/:slug" element={<ProductDetail data-id="element-16" />} data-id="element-15" />
            <Route path="compare" element={<Compare data-id="element-18" />} data-id="element-17" />
            <Route path="cart" element={<Cart data-id="element-20" />} data-id="element-19" />
            <Route path="contact" element={<Contact data-id="element-22" />} data-id="element-21" />
            <Route path="faq" element={<FAQ data-id="element-24" />} data-id="element-23" />
            <Route path="*" element={<NotFound data-id="element-26" />} data-id="element-25" />
          </Route>
        </Routes>
      </BrowserRouter>
    </CartProvider>;
}